import { MAJOR_PATHS } from '../majorPaths';

export const MAJOR_REPORTS_NAV_GROUPS = [
  {
    key: 'nursing',
    labelKey: 'SUBNAV_GROUP_NURSING',
    items: [
      {
        to: MAJOR_PATHS.RAPPORTS,
        end: true,
        labelKey: 'SUB_OVERVIEW',
        navKey: 'reportsOverview'
      },
      {
        to: MAJOR_PATHS.RAPPORTS_SOINS,
        end: false,
        labelKey: 'SUB_SOINS',
        navKey: 'reportsSoins'
      },
      {
        to: MAJOR_PATHS.RAPPORTS_INJECTIONS,
        end: false,
        labelKey: 'SUB_INJECTIONS',
        navKey: 'reportsInjections'
      },
      {
        to: MAJOR_PATHS.RAPPORTS_TESTS,
        end: false,
        labelKey: 'SUB_TESTS',
        navKey: 'reportsTests'
      },
      {
        to: MAJOR_PATHS.RAPPORTS_VACCINS,
        end: false,
        labelKey: 'SUB_VACCINS',
        navKey: 'reportsVaccins'
      },
      {
        to: MAJOR_PATHS.RAPPORTS_PLANNING_FAMILIAL,
        end: false,
        labelKey: 'SUB_PLANNING_FAMILIAL',
        navKey: 'reportsPlanningFamilial'
      }
    ]
  }
];

export { REPORTS_PERIOD_PRESETS } from '../../head-doctor/reports/reportsNavConfig';
